module.exports = __webpack_public_path__ + "media/winningSound.9fdc63bf.mp3";